import {Injectable} from "@angular/core";
import {ApiService} from "../../../../shared/services/api/api.service";
import {IGetStaffList} from "../interface/staff.interface";
import {Observable} from "rxjs";
import {IPagination} from "../../../../shared/services/api/interface/pagination.interface";

@Injectable({
  providedIn: 'root'
})
export class StaffService {
  constructor(private readonly apiService: ApiService) {
  }

  getStaffList(){
    return this.apiService.get<IGetStaffList[]>('staff');
  }

  getAllStaffWithDeactive(){
    return this.apiService.get<IGetStaffList[]>('staff/staff-list-deactive');
  }

  getStaffDropdown(filter:{isActive?:boolean}){
    return this.apiService.post<any[]>('staff/staff-list-dropdown',filter);
  }


  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`staff/staff-filter-list`, {event: event, filter: filter})
  }

  getById(id: string){
    return this.apiService.get(`staff/${id}`);
  }

  createStaff(formData: FormData){
    return this.apiService.post('staff/create', formData);
  }
  updateStaff(formData: FormData){
    return this.apiService.patch('staff/update', formData);
  }

  deleteStaff(id: number){
    return this.apiService.delete(`staff/delete/${id}`);
  }

  getStaffSelectInCase() {
    return this.apiService.post<any[]>('staff/staff-select-in-case', {});
  }

  getStaffSelectInCaseWithCity() {
    return this.apiService.post<any[]>('staff/staff-select-in-case-appointment', {});
  }


  getSelectableInCaseWithBusy(params: { date: string }) {
    return this.apiService.post<any[]>(
      'staff/selectable-in-case-with',
      params
    );
  }




}
